import { AbstractControl, ValidationErrors } from "@angular/forms";


export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value || '';

  if (!value) {
    return null;
  }

  const errors: ValidationErrors = {};

  if (value.length < 8) {
    errors['minLength'] = true;
  }

  if (!/[a-z]/.test(value)) {
    errors['lowercase'] = true;
  }

  if (!/[A-Z]/.test(value)) {
    errors['uppercase'] = true;
  }

  if (!/\d/.test(value)) {
    errors['number'] = true;
  }

  if (!/^(?=.*[$#%.])[A-Za-z\d$#%.]+$/.test(value)) {
    errors['invalidCharacters'] = true;
  }

  return Object.keys(errors).length ? errors : null;
}
